import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaOverviewCashPage } from './plaza-overview-cash';

@NgModule({
  declarations: [
    PlazaOverviewCashPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaOverviewCashPage),
    TranslateModule.forChild()
  ],
})
export class PlazaOverviewCashPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview-cash/plaza-overview-cash.module.ts